// extracted by mini-css-extract-plugin
export default {"withdraw":"style_withdraw__HDEc8","wrapper":"style_wrapper__14stR","asset":"style_asset__UiEYQ","amount":"style_amount__UIKKk"};